import { compose } from "recompose";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded, getVal } from "react-redux-firebase";
import CustomersForm from "components/Customers/CustomersForm";
import {
  createCustomer,
  updateCustomer,
  deleteCustomer,
} from "actions/customers/customersActions";
import * as routes from "constants/routes";

const handleFormSubmit = props => formValues => {
  return props.updateCustomer(formValues).then(() => {
    props.history.push(routes.CUSTOMERS);
  });
};

const mapStateToProps = (state, ownProps) => {
  const { firestore, firebase } = state;

  const docId = ownProps.match.params.id;

  const customers = state.firestore.data.customers;
  const regions = firestore.ordered.regions;
  const equipments = firestore.ordered.equipments;
  const agreements = firestore.ordered.agreements;

  const customer = getVal(customers, docId);
  const auth = firebase.auth;

  const error = state.customers.error;
  const initialValues = { ...customer };
  const formInitValues = { regions, equipments, agreements };

  const isLoading =
    !isLoaded(customers) &&
    !isLoaded(regions) &&
    !isLoaded(equipments) &&
    !isLoaded(agreements);

  return {
    isLoading: isLoading,
    initialValues: initialValues,
    formInitValues: formInitValues,
    onSubmit: handleFormSubmit(ownProps),
    isEditing: true,
    auth: auth,
    error: error,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const docId = ownProps.match.params.id;
  return {
    createCustomer: formValues => dispatch(createCustomer(formValues)),
    updateCustomer: formValues => dispatch(updateCustomer(docId, formValues)),
    deleteCustomer: () => dispatch(deleteCustomer(docId)),
  };
};

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
  firestoreConnect([
    { collection: "customers" },
    { collection: "regions" },
    { collection: "equipments" },
    { collection: "agreements" },
  ]),
  connect(mapStateToProps)
)(CustomersForm);
